<template>
    <div>
        <div class="form-container">
            <!-- <div class="form-groupx">
          <label for="trial-no">Trial No</label>
            <input type="text" id="trial-no" :value="trials.trial_no" readonly />
        </div> -->
            <div class="form-groupx">
                <label for="start-date">Trial Start Date</label>
                <input type="text" id="start-date" :value="trials.start_date" readonly />
            </div>
            <div class="form-groupx">
                <label for="end-date">Trial End Date</label>
                <input type="text" id="end-date" v-model="trials.end_date" readonly />
            </div>
        </div>

        <md-card>
            <md-card-content>
                <div class="header-sec"></div>
                <md-card-header data-background-color="green" style="margin: 0px 0px 1%">
                    <h4 class="title">Feed Consumption Per Bird (in KGS)</h4>
                </md-card-header>
                <div>
                    <div class="row align-items-center mb-3">
                        <div class="col-auto">
                            <ul class="nav nav-pills">
                                <li class="nav-item">
                                    <a href="#" :class="['nav-link', { active: isActive('view') }]"
                                        @click.prevent="setActiveTab('view')">
                                        View
                                    </a>
                                </li>
                                <li class="nav-item" v-if=" permissionData.add && permissionData.edit && isLatest">
                                    <a href="#" :class="['nav-link', { active: isActive('create') }]"
                                        @click.prevent="setActiveTab('create')">
                                        Create / Edit
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <form v-if="activeTab === 'view'">
                    <div class="row align-items-center mb-1 justify-content-around">
                        <!-- <div class="col-auto"> -->
                        <label class="font-weight-bold" for="">Select Day:
                            <select style="width: 100px; height: 40px" v-model="dayWeekView"
                                @change="fetchViewFeedData()">
                                <option value="" disabled>Select Day</option>
                                <option v-for="day in availableDays" :value="day.value" :key="day.value">{{ day.label }}
                                </option>
                            </select>
                        </label>
                        <label v-if="showDate" class="font-weight-bold mb-3" for="">Date:
                            <input type="text" :value="showDate" readonly>
                        </label>
                        <!-- <label class="font-weight-bold" for="">Trial Group
                            <select v-model="selectedTrialGroup" style="width: 100px; height: 40px">
                                <option v-for="(item, trialIndex) in trialGroupList" :value="item.id" :key="trialIndex">{{ item.trial_group_id }}</option>
                            </select>
                        </label> -->
                        <!-- </div> -->
                    </div>
                    <md-table id="myTable" v-if="loadingView || !isFeedDataFetchedView || !feedDataView.length > 0">
                        <thead>
                            <tr>
                                <th>Pen No.</th>
                                <th>Feed Category</th>
                                <th>Formula</th>
                                <th>No of Birds</th>
                                <!-- <th>Feeder</th> -->
                                <th>Feeder with Feed Wt(Kgs)</th>
                                <th>Feeder Tare Wt(Kgs)</th>
                                <th>Remaining Feed in Feeder (Kgs)</th>
                                <th>Feeder Drum with Feed Wt(Kgs)</th>
                                <th>Feeder Drum Tare Wt(Kgs)</th>
                                <th>Remaining Feed in Feeder Drum (Kgs)</th>
                                <!-- <th>Alloted Feed PST (Kgs)</th>
                            <th>Alloted Feed ST (Kgs)</th>
                            <th>Alloted Feed FN1 (Kgs)</th>
                            <th>Alloted Feed FN2 (Kgs)</th> -->
                                <th>Total Alloted Feed (Kgs)</th>
                                <th>Total Remaining Feed (Kgs)</th>
                                <th>Consumed Feed (Kgs)</th>
                                <th>Feed Consumed Per Bird (Kgs)</th>
                                <th>FCR</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="loadingView">
                                <td colspan="18"><loading-bar></loading-bar></td>
                            </tr>
                            <tr v-else>
                                <td colspan="18">No data found</td>
                            </tr>
                        </tbody>
                    </md-table>
                    <md-table v-else id="myTable" v-for="(penList, indexMain) in feedDataView" :key="indexMain">
                        <thead>
                            <tr>
                                <th colspan="1" style="background-color: #64B968; color: white">{{ 'T' +
                                    penList.trial_group_id }}</th>
                            </tr>
                            <tr>
                                <th>Pen No.</th>
                                <th>Feed Category</th>
                                <th v-if="feedDataView.some(penList => penList.data.some(pen => pen.formula))">Formula
                                </th>
                                <th>No of Birds</th>
                                <!-- <th>Feeder</th> -->
                                <th>Feeder with Feed Wt(Kgs)</th>
                                <th>Feeder Tare Wt(Kgs)</th>
                                <th>Remaining Feed in Feeder (Kgs)</th>
                                <th>Feeder Drum with Feed Wt(Kgs)</th>
                                <th>Feeder Drum Tare Wt(Kgs)</th>
                                <th>Remaining Feed in Feeder Drum (Kgs)</th>
                                <th class="font-weight-bold"
                                    v-if="feedDataView.some(penList => penList.data.some(pen => pen.alloted_feed_pst))">
                                    Alloted Feed PST (Kgs)</th>
                                <th class="font-weight-bold"
                                    v-if="feedDataView.some(penList => penList.data.some(pen => pen.alloted_feed_st))">
                                    Alloted Feed ST (Kgs)</th>
                                <th class="font-weight-bold"
                                    v-if="feedDataView.some(penList => penList.data.some(pen => pen.alloted_feed_fn1))">
                                    Alloted Feed FN1 (Kgs)</th>
                                <th class="font-weight-bold"
                                    v-if="feedDataView.some(penList => penList.data.some(pen => pen.alloted_feed_fn2))">
                                    Alloted Feed FN2 (Kgs)</th>
                                <th>Total Alloted Feed (Kgs)</th>
                                <th>Total Remaining Feed (Kgs)</th>
                                <th>Consumed Feed (Kgs)</th>
                                <th>Feed Consumed Per Bird (Kgs)</th>
                                <th>FCR</th>
                            </tr>
                        </thead>
                        <tbody v-if="loadingView">
                            <tr>
                                <td colspan="18"><loading-bar></loading-bar></td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="(pen, index) in penList.data" :key="index">
                                <!-- <template v-if="index === 0">
                                <td rowspan="5">
                                    <select v-model="selectedChickCategory" style="width: 110px; height: 40px" class="font-weight-bold" disabled>
                                        <option v-for="(chick, chickIndex) in chickCategoryList" :value="chick.id" :key="chickIndex">{{ chick.category_name }}</option>
                                    </select>
                                </td>
                                <td rowspan="5" v-if="selectedChickCategory == 3">
                                        <div style="display: flex; align-items: center;">
                                            <label style="margin-right: 10px; font-size: 14px;">
                                                <input type="radio" v-model="selectedFormula" :value="1" style="transform: scale(0.8); margin-right: 4px;" disabled/>
                                                FN 1
                                            </label>
                                            <label style="font-size: 14px;">
                                                <input type="radio" v-model="selectedFormula" :value="2" style="transform: scale(0.8); margin-right: 4px;" disabled>
                                                FN 2
                                            </label>
                                        </div>
                                    </td>
                            </template> -->
                                <td class="font-weight-bold">{{ pen.pen_name || '-'}}</td>
                                <td class="font-weight-bold" style="font-size: 13px;">{{
                                    getFeedCategoryName(pen.chick_category) || '-' }}</td>
                                <td class="font-weight-bold" style="font-size: 13px;"
                                    v-if="penList.data.some(pen => pen.formula)"> {{ pen.formula ? (pen.formula == 1 ?
                                    'FN1' : 'FN2') : '-' }}</td>
                                <td>{{ pen.no_of_birds || '-' }}</td>
                                <!-- <td>
                                <select name="" id="" v-model="pen.feeder" class="font-weight-bold" disabled>
                                    <option value="" selected disabled>Select</option>
                                    <option :value="item.id" v-for="(item, feederIndex) in feederMasterData" :key="feederIndex">{{ item.weight_type }}</option>
                                </select>
                            </td> -->
                                <td>{{ pen.feeder_with_feed || '-'}}</td>
                                <td>{{ pen.feeder_tare_wt || '-'}}</td>
                                <td class="font-weight-bold">{{ formatDecimalPoints(pen.remaining_feed_from_feeder) ||
                                    '-' }}</td>
                                <td>{{ pen.feeder_drum_with_feed || '-' }}</td>
                                <td>{{ pen.feeder_drum_tare_wt || '-'}}</td>
                                <td class="font-weight-bold">{{ formatDecimalPoints(pen.remaining_feed_from_feeder_drum)
                                    || '-' }}</td>
                                <td class="font-weight-bold" v-if="penList.data.some(pen => pen.alloted_feed_pst)">{{
                                    pen.alloted_feed_pst ? formatDecimalPoints(pen.alloted_feed_pst) : '-' }}</td>
                                <td class="font-weight-bold" v-if="penList.data.some(pen => pen.alloted_feed_st)">{{
                                    pen.alloted_feed_st ? formatDecimalPoints(pen.alloted_feed_st) : '-' }}</td>
                                <td class="font-weight-bold" v-if="penList.data.some(pen => pen.alloted_feed_fn1)">{{
                                    pen.alloted_feed_fn1 ? formatDecimalPoints(pen.alloted_feed_fn1) : '-' }}</td>
                                <td class="font-weight-bold" v-if="penList.data.some(pen => pen.alloted_feed_fn2)">{{
                                    pen.alloted_feed_fn2 ? formatDecimalPoints(pen.alloted_feed_fn2) : '-' }}</td>
                                <td class="font-weight-bold">{{ formatDecimalPoints(pen.total_alloted_feed) || '-' }}
                                </td>
                                <td class="font-weight-bold">{{ formatDecimalPoints(pen.remaining_feed) || '-' }}</td>
                                <td class="font-weight-bold">{{ formatDecimalPoints(pen.consumed_feed) || '-'}}</td>
                                <td class="font-weight-bold">{{ formatDecimalPoints(pen.feed_consumed_per_bird) || '-'}}
                                </td>
                                <td class="font-weight-bold">{{ formatDecimalPoints(pen.fcr) || '-'}}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td v-if="penList.data.some(pen => pen.formula)"></td>
                                <td style="background-color: #8E41B4; color: white" class="font-weight-bold">{{
                                    penList.totals.total_no_of_birds || '-' }}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td v-if="penList.data.some(pen => pen.alloted_feed_pst)"></td>
                                <td v-if="penList.data.some(pen => pen.alloted_feed_st)"></td>
                                <td v-if="penList.data.some(pen => pen.alloted_feed_fn1)"></td>
                                <td v-if="penList.data.some(pen => pen.alloted_feed_fn2)"></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td style="background-color: #8E41B4; color: white" class="font-weight-bold">{{
                                    penList.totals.total_feed_consumed_per_bird || '-' }}</td>
                                <td style="background-color: #8E41B4; color: white" class="font-weight-bold">{{
                                    penList.totals.total_fcr || '-' }}</td>
                            </tr>
                        </tbody>
                    </md-table>
                    <!-- <div class="sec-row">
                    <div></div>
                    <div></div>
                    <div v-if="showButtons">
                        <md-button v-if="isFeedDataFetched" @click.prevent="setActiveTab('create')" class="md-success">Edit</md-button>
                    </div>
                </div> -->
                </form>

                <form v-if="activeTab === 'create'">
                    <!-- <div class="d-flex align-items-center">
                    <label class="font-weight-bold mr-3" for="">Feed Category: 
                        <select v-model="selectedChickCategory" style="width: 110px; height: 40px" @change="feedCalculation()" :disabled="isFeedDataFetched || disableChickCategoryButton || loading">
                            <option value="" selected disabled>Select</option>
                            <option v-for="(chick, chickIndex) in chickCategoryList" :value="chick.id" :key="chickIndex">{{ chick.category_name }}</option>
                        </select>
                    </label>
                        
                    <div v-if="selectedChickCategory == 3" class="d-flex align-items-center">
                        <label class="font-weight-bold" style="font-size: 14px;">FN1 <input type="radio" v-model="selectedFormula" @change="feedCalculation()" :value="1" /></label>
                        <label class="font-weight-bold" style="font-size: 14px;">FN2 <input type="radio" v-model="selectedFormula" @change="feedCalculation()" :value="2" /></label>
                    </div>
                </div> -->
                    <md-table id="myTable">
                        <thead>
                            <tr>
                                <th style="width: 100px">Select Day</th>
                                <!-- <th>Feed Category</th>
                            <th v-if="selectedChickCategory == 3">Formula</th> -->
                                <th>Trial Group</th>
                                <th>Pen No.</th>
                                <th>Feed Category
                                    <select v-if="!loading && !saveStatus && !upDateStatus && penList.length > 0"
                                        v-model="selectedFeedCategory" style="width: 110px; height: 40px"
                                        @change="setFeedCategoryForAllPens()">
                                        <option value="" selected disabled>Select</option>
                                        <option v-for="(chick, chickIndex) in chickCategoryList" :value="chick.id"
                                            :key="chickIndex">{{ chick.category_name }}</option>
                                    </select>
                                </th>
                                <th v-if="penList.some( pen => pen.chick_category == 3)">Formula
                                    <select v-if="(penList.some( pen => pen.chick_category == 3)) && !loading"
                                        v-model="selectedFormula" @change="setFeedCategoryForAllPens()">
                                        <option value="" selected disabled>Select</option>
                                        <option :value="1">FN1</option>
                                        <option :value="2">FN2</option>
                                    </select>
                                </th>
                                <th>No of Birds</th>
                                <!-- <th>Feeder</th> -->
                                <th>Feeder with Feed Wt(Kgs)</th>
                                <th>Feeder Tare Wt(Kgs)
                                    <select v-if="!loading && !saveStatus && !upDateStatus && penList.length > 0"
                                        name="" id="" v-model="selectedFeeder"
                                        @change="showWarningForChickCategory(), getFeederTareWeight(selectedFeeder)">
                                        <option value="" selected disabled>Select</option>
                                        <option :value="item.id" v-for="(item, feederIndex) in feederMasterData"
                                            :key="feederIndex">{{ item.weight_type }}</option>
                                    </select>
                                </th>
                                <th>Remaining Feed in Feeder (Kgs)</th>
                                <th>Feeder Drum with Feed Wt(Kgs)</th>
                                <th>Feeder Drum Tare Wt(Kgs)</th>
                                <th>Remaining Feed in Feeder Drum (Kgs)</th>
                                <th class="font-weight-bold" v-if="penList.some(pen => pen.alloted_feed_pst)">Alloted
                                    Feed PST (Kgs)</th>
                                <th class="font-weight-bold" v-if="penList.some(pen => pen.alloted_feed_st)">Alloted
                                    Feed ST (Kgs)</th>
                                <th class="font-weight-bold" v-if="penList.some(pen => pen.alloted_feed_fn1)">Alloted
                                    Feed FN1 (Kgs)</th>
                                <th class="font-weight-bold" v-if="penList.some(pen => pen.alloted_feed_fn2)">Alloted
                                    Feed FN2 (Kgs)</th>
                                <th>Total Alloted Feed (Kgs)</th>
                                <th>Total Remaining Feed (Kgs)</th>
                                <th>Consumed Feed (Kgs)</th>
                                <th>Feed Consumed Per Bird (Kgs)</th>
                            </tr>
                        </thead>
                        <tbody v-if="(loading && !isFeedDataFetched)|| saveStatus || upDateStatus">
                            <tr v-if="loading || saveStatus || upDateStatus">
                                <td colspan="21"><loading-bar></loading-bar></td>
                            </tr>
                            <tr v-else>
                                <td colspan="21">No data found</td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-if="showError">
                                <td colspan="21">No data found</td>
                            </tr>
                            <tr v-else v-for="(pen, index) in penList" :key="index">
                                <template v-if="index === 0">
                                    <td :rowspan="penList.length" style="padding-right: 10px;padding-left: 10px;">
                                        <select style="width: 165px; height: 40px" v-model="dayWeek"
                                            @change="fetchFeedConsumptionData()">
                                            <option v-for="day in dayList" :value="day.value" :key="day.value">{{
                                                day.label }}</option>
                                        </select>
                                        <input type="date" class="form-control p-2 mt-2 rounded"
                                            style="width: 165px; height: 40px; border: 1px solid black"
                                            v-model="selectedDate" required :disabled="isDateFetched && selectedDate || isSelectedDateFetched" />
                                    </td>
                                    <!-- <td rowspan="5">
                                    <select v-model="selectedChickCategory" style="width: 110px; height: 40px" @change="feedCalculation()">
                                        <option value="" selected disabled>Select</option>
                                        <option v-for="(chick, chickIndex) in chickCategoryList" :value="chick.id" :key="chickIndex">{{ chick.category_name }}</option>
                                    </select>
                                </td>
                                <td rowspan="5" v-if="selectedChickCategory == 3">
                                    <div style="display: flex; align-items: center;">
                                        <label style="margin-right: 10px; font-size: 14px;">
                                            <input type="radio" v-model="selectedFormula" @change="feedCalculation()" value="1" style="transform: scale(0.8); margin-right: 4px;" />
                                            FN 1
                                        </label>
                                        <label style="font-size: 14px;">
                                            <input type="radio" v-model="selectedFormula" @change="feedCalculation()" value="2" style="transform: scale(0.8); margin-right: 4px;" />
                                            FN 2
                                        </label>
                                    </div>
                                </td> -->
                                    <td :rowspan="penList.length">
                                        <select v-model="selectedTrialGroup" @change="fetchFeedConsumptionData()"
                                            style="width: 100px; height: 40px">
                                            <option v-for="(item, trialIndex) in trialGroupList" :value="item.id"
                                                :key="trialIndex">{{ item.trial_group_id }}</option>
                                        </select>
                                    </td>
                                </template>
                                <td class="font-weight-bold">{{ pen.pen_name }}</td>
                                <td class="font-weight-bold">
                                    <select v-model="pen.chick_category" style="width: 110px; height: 40px"
                                        @change="feedCalculation(pen, index), showWarningForChickCategory(pen)"
                                        :disabled="loading">
                                        <option value="" selected disabled>Select</option>
                                        <option v-for="(chick, chickIndex) in chickCategoryList" :value="chick.id"
                                            :key="chickIndex">{{ chick.category_name }}</option>
                                    </select>
                                </td>
                                <td v-if="penList.some( pen => pen.chick_category == 3)">
                                    <select v-if="pen.chick_category == 3" v-model="pen.formula"
                                        @change="feedCalculation(pen, index)" :disabled="loading">
                                        <option value="" selected disabled>Select</option>
                                        <option :value="1">FN1</option>
                                        <option :value="2">FN2</option>
                                    </select>
                                    <span v-else>{{'-'}}</span>
                                </td>
                                <td><input type="text" v-model="pen.no_of_birds" @input="calculateFeed(index)"
                                        @keydown="navigateInput(index, $event, 'no_of_birds')"
                                        :ref="'input-' + index + '-no_of_birds'"></td>
                                <!-- <td>
                                <select name="" id="" v-model="pen.feeder" @change="showWarningForChickCategory(pen), getFeederTareWeight(index, pen.feeder), debounceValidateInput(pen.feeder_with_feed, pen.feeder_tare_wt, 'feeder')">
                                    <option value="" selected disabled>Select</option>
                                    <option :value="item.id" v-for="(item, feederIndex) in feederMasterData" :key="feederIndex">{{ item.weight_type }}</option>
                                </select>
                            </td> -->
                                <td><input type="text" v-model="pen.feeder_with_feed" @input="calculateFeed(index)"
                                        @blur="debounceValidateInput(pen.feeder_with_feed, pen.feeder_tare_wt, 'feeder')"
                                        @keydown="navigateInput(index, $event, 'feeder_with_feed')"
                                        :ref="'input-' + index + '-feeder_with_feed'"></td>
                                <td class="font-weight-bold">{{ pen.feeder_tare_wt || '-' }}</td>
                                <td class="font-weight-bold">{{ formatDecimalPoints(pen.remaining_feed_from_feeder) ||
                                    '-' }}</td>
                                <td><input type="text" v-model="pen.feeder_drum_with_feed" @input="calculateFeed(index)"
                                        @blur="debounceValidateInput(pen.feeder_drum_with_feed, pen.feeder_drum_tare_wt, 'feeder_drum')"
                                        @keydown="navigateInput(index, $event, 'feeder_drum_with_feed')"
                                        :ref="'input-' + index + '-feeder_drum_with_feed'"></td>
                                <td class="font-weight-bold"><input type="text" v-model="pen.feeder_drum_tare_wt"
                                        @input="calculateFeed(index)"
                                        @blur="debounceValidateInput(pen.feeder_drum_with_feed, pen.feeder_drum_tare_wt, 'feeder_drum')"
                                        @keydown="navigateInput(index, $event, 'feeder_drum_tare_wt')"
                                        :ref="'input-' + index + '-feeder_drum_tare_wt'"></td>
                                <td class="font-weight-bold">{{ formatDecimalPoints(pen.remaining_feed_from_feeder_drum)
                                    || '-' }}</td>
                                <td class="font-weight-bold" v-if="penList.some(pen => pen.alloted_feed_pst)">{{
                                    formatDecimalPoints(pen.alloted_feed_pst) || '-' }}</td>
                                <td class="font-weight-bold" v-if="penList.some(pen => pen.alloted_feed_st)">{{
                                    formatDecimalPoints(pen.alloted_feed_st) || '-' }}</td>
                                <td class="font-weight-bold" v-if="penList.some(pen => pen.alloted_feed_fn1)">{{
                                    formatDecimalPoints(pen.alloted_feed_fn1) || '-' }}</td>
                                <td class="font-weight-bold" v-if="penList.some(pen => pen.alloted_feed_fn2)">{{
                                    formatDecimalPoints(pen.alloted_feed_fn2) || '-' }}</td>
                                <td class="font-weight-bold">{{ formatDecimalPoints(pen.total_alloted_feed) || '-' }}
                                </td>
                                <td class="font-weight-bold">{{ formatDecimalPoints(pen.remaining_feed) || '-' }}</td>
                                <td class="font-weight-bold">{{ formatDecimalPoints(pen.consumed_feed) || '-' }}</td>
                                <td class="font-weight-bold">{{ formatDecimalPoints(pen.feed_consumed_per_bird) || '-'
                                    }}</td>
                            </tr>
                        </tbody>
                    </md-table>

                    <div v-if="!loading && isEditable" class="sec-row">
                        <!-- <div>
                    <md-button @click="addin2" class="md-primary">Add Row</md-button>
                    </div>
                    <div></div> -->
                        <div v-if="showButtons">
                            <md-button v-if="isFeedDataFetched" type="submit" @click.prevent="submit('update')"
                                class="md-success">{{ upDateStatus == true ? 'Updating...' : 'Update' }}</md-button>
                            <md-button v-else type="submit" @click.prevent="submit('save')" class="md-success">{{
                                saveStatus == true ? 'Saving...' : 'Save' }}</md-button>
                        </div>
                        <div v-if="showButtons && isFeedDataFetched">
                            <!-- <md-button @click.prevent="setActiveTab('view')" class="btn btn-secondary">Cancel</md-button> -->
                            <md-button @click.prevent="fetchFeedConsumptionData()"
                                class="btn btn-secondary">Cancel</md-button>
                        </div>
                        <div v-if="showButtons && !isFeedDataFetched">
                            <md-button type="button" @click.prevent="clearFields('reset')"
                                class="md-danger">Reset</md-button>
                        </div>
                        <!-- @click="resetBw"  -->
                    </div>
                </form>
            </md-card-content>
        </md-card>
    </div>
</template>
  
  <script>
  import LoadingBar from "../components/LoadingBar.vue";
  import moment from "moment";
  export default {
    components: {
        LoadingBar,
    },
  props: {
    
  },
  data() {
    return {
        isDateFetched: false,
        selectedDate: null,
        isSelectedDateFetched: false,
        loading: false,
        isEditable: null,
        isLatest : false,
        loadingView: false,
        isFeedDataFetchedView: false,
        activeTab: 'view',
        trials: [],
        selectedTrial: null,
        startDate: '',
        currentDate: '',
        showDate: null,
        allotedFeedError: [],
        feederMasterData: [],
        trialGroupList: [],
        selectedTrialGroup: null,
        penList: [],
        feedDataView: [],
        chickCategoryList: [],
        // disableChickCategoryButton: false,
        selectedFeedCategory: "",
        selectedFormula: "",
        selectedFeeder: "",
        showError: false,
        // selectedChickCategory: '',
        // selectedFormula: null,
        // selectedChickCategoryView: '',
        selectedFormulaView: null,
        dayWeek: 1,
        dayWeekView: '',
        saveStatus: false,
        upDateStatus: false,
        isFeedDataFetched: false,
        showButtons: false,
        dayList: this.createDayList(),
        availableDays: [],
        allotedFeed: [],
        permissionData: {},
        // debounce: null,
    };
  },
  mounted() {
    this.permissionData = this.$store.getters.getActiveSideBar.permissions[0];
    this.trials = this.$store.getters.getSelectedTrial;
    this.selectedTrial = this.trials.id;
    this.checkLatestExperiment();
    this.selectedTrial = this.trials.id;
    this.fetchFeederMasterDetails();    
  },
  watch:{
    selectedTrialGroup(newVal, oldVal) {
      this.checkIsEditable();
    },
  },
  methods: {
    navigateInput(index, event, field) {
        if (event.keyCode === 38) {
            if (index > 0) {
                const previousIndex = index - 1;
                this.$refs[`input-${previousIndex}-${field}`][0].focus();
            }
        } else if (event.keyCode === 40) {
            if (index < this.penList.length - 1) {
                const nextIndex = index + 1;
                this.$refs[`input-${nextIndex}-${field}`][0].focus();
            }
        }
    },
    async checkIsEditable() {
    try {
        const response = await axios.get(`indous-research/check-is-editable/${this.selectedTrial}/${this.selectedTrialGroup}`);
        
        this.isEditable = response.data.isEditable;

        if (this.isEditable === false) {
        this.$notify({
            message: "Kindly verify and submit in Corrected feed formula",
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'danger'
        });
        }
    } catch (error) {
        // console.error("Error fetching isEditable status:", error);
    }
    },
    debounceValidateInput(value, dynamicValue, key){
        // if(this.debounce) clearTimeout(this.debounce);
        // this.debounce = setTimeout(()=>{
        if(value && dynamicValue){
            if(Number(value) < Number(dynamicValue)){
                this.$notify({
                    message: key == 'feeder' ? 'Feeder with Feed Wt cannot be less than feeder tare weight' : 'Feeder drum with Feed Wt cannot be less than feeder drum tare weight',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            };
        }       
        // }, 1500);
    },
    showWarningForChickCategory(pen){
        if(pen){
            if(pen.chick_category == '' || pen.chick_category == null){
                this.$notify({
                            message: 'Please select the Feed Category for ' + pen.pen_name,
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'warning'
                        });
            } else if(pen.chick_category == 3 && (pen.formula == null || pen.formula == '')){
                this.$notify({
                            message: 'Please select the Formula for ' + pen.pen_name,
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'warning'
                        });
            }
        } else {
            const result = this.penList.find( pen => {
                return pen.chick_category == '';
            });
            if(result){
                this.$notify({
                        message: 'Please select the Feed Category for each pen',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'warning'
                    });
            }
        }
    },
    setFeedCategoryForAllPens(){
        if (this.selectedFeedCategory) {
            // this.penList.forEach((pen, index) => {
                // pen.chick_category = this.selectedFeedCategory;
                // pen.formula = this.selectedFormula;
                this.feedCalculation(null, null);
            // });
        }
    },
    checkLatestExperiment() {
      axios
        .get(`/indous-research/check-latest-experiment`)
        .then((response) => {
          this.isLatest = response.data.is_latest;
        })
        .catch((error) => {
          // console.error("Error checking latest experiment:", error);
        });
    },
    getFeedCategoryName(chickId){
        const chickData = this.chickCategoryList.find( item => item.id == chickId);
        return chickData.category_name;
    },
    createDayList() {
        const days = [];
        for (let i = 1; i <= 35; i++) {
            if (i === 7) {
                days.push({ value: i, label: 'week1' });
            } else if (i === 14) {
                days.push({ value: i, label: 'week2' });
            } else if (i === 21) {
                days.push({ value: i, label: 'week3' });
            } else if (i === 28) {
                days.push({ value: i, label: 'week4' });
            } else if (i === 35) {
                days.push({ value: i, label: 'week5' });
            } else {
                days.push({ value: i, label: i.toString() });
            }
        }
        return days;
    },
    isActive(tab) {
      return this.activeTab === tab;
    },
    setActiveTab(tab) {
        this.activeTab = tab;
        // this.loading = true;
        this.showButtons = false;
        if(this.activeTab == 'view'){
            this.getAvailableDaysList();
        } else {
            this.fetchTrialGroup();
        }
    },

    fetchFeederMasterDetails(){
        this.loading = true;
        this.loadingView = true;
        axios.get('/feeder-master')
            .then((response) => {
                this.feederMasterData = response.data;
                this.fetchFeederDrumMasterDetails();
            }).catch((error) => {
                this.loading = false;
                this.loadingView = false;
                this.$notify({
                        message: error.response.data.message || 'An error occurred',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });
                // console.error('Error fetching Feeder details:', error);
            })
    },

    fetchFeederDrumMasterDetails(){
        axios.get('/feeder-drum-master')
            .then((response) => {
                this.feederDrumMasterData = response.data;
                this.fetchChickCategory();
            }).catch((error) => {
                this.loading = false;
                this.loadingView = false;
                this.$notify({
                        message: error.response.data.message || 'An error occurred',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });
                // console.error('Error fetching Feeder drum details:', error);
            })
    },

    fetchChickCategory(){
        this.loading = true;
        this.loadingView = true;
        this.isFeedDataFetchedView = false;
        this.isFeedDataFetched = false;
        axios.get('/chick-category').then((response) => {
            this.chickCategoryList = response.data;
            // this.fetchTrials();
            // if(this.selectedTrial){
            //     this.fetchTrialDetails();
            // }
            if(this.activeTab == 'view'){
                this.getAvailableDaysList();
            } else {
                this.fetchTrialGroup();
            }
        }).catch((error) => {
            this.loading = false;
            this.loadingView = false;
            this.$notify({
                        message: error.response.data.message || 'An error occurred',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });
            this.loading = false;
            this.loadingView = false;
        });
    },

    // fetchTrials() {
    //     this.loading = true;
    //     this.loadingView = true;
    //     axios.get('/indous-research/master/trials')
    //         .then((response) => {
    //             this.trials = response.data;
    //             if (this.trials.length > 0) {
    //                 this.selectedTrial = this.trials[0].id; 
    //                 this.fetchTrialDetails(); 
    //             }
    //         })
    //         .catch((error) => {
    //             this.loading = false;
    //             this.loadingView = false;
    //         //   console.error('Error fetching trials:', error);
    //         });
    // },
    // fetchTrialDetails() {
    //     this.loading = true;
    //     this.loadingView = true;
    //     this.isFeedDataFetchedView = false;
    //     this.isFeedDataFetched = false;
    //     axios.get(`/indous-research/master/trial/${this.selectedTrial}`)
    //         .then((response) => {
    //             const data = response.data;
    //             const [day, month, year] = data.start_date.split('-');
    //             const startDate = new Date(year, month - 1, day);
    //             this.startDate = startDate.toLocaleDateString('en-GB');
    //             this.currentDate = new Date().toLocaleDateString('en-GB'); 
    //             if(this.activeTab == 'view'){
    //                 this.getAvailableDaysList();
    //             } else {
    //                 this.fetchTrialGroup();
    //             }
    //         })
    //         .catch((error) => {
    //             this.loading = false;
    //             this.loadingView = false;
    //         //   console.error('Error fetching trial details:', error);
    //         });
    // },

    getAvailableDaysList(){
        this.loadingView = true;
        // this.selectedChickCategoryView = '';
        // this.selectedFormulaView = null;
        this.availableDays = [];
        this.dayWeekView = '';
        this.feedDataView = [];
        this.$forceUpdate();
        axios
        .post("/get-days-list", {
          experiment_info_id: this.selectedTrial,
        })
        .then((response) => {
          this.availableDays = response.data;
          this.dayWeekView = this.availableDays.length > 0 ? this.availableDays[0].value : '';
          this.fetchViewFeedData();
        })
        .catch((error) => {
            this.loading = false;
            this.loadingView = false;
        //   console.error("Error fetching days:", error);
        });
    },

    fetchViewFeedData(){
        this.loadingView = true;
        this.feedDataView = [];
        this.$forceUpdate();
        this.isFeedDataFetchedView = false;
        // this.selectedChickCategoryView = '';
        // this.selectedFormulaView = null;
        if(this.selectedTrial && this.dayWeekView){
            axios.get(`/show-feed-consumed-data?expId=${this.selectedTrial}&dayWeek=${this.dayWeekView}`)
            .then((response) => {
                this.feedDataView = response.data;
                this.showDate = response.data.length > 0 && response.data[0].data[0].date
                                ? moment(response.data[0].data[0].date, 'YYYY-MM-DD').format('DD-MM-YYYY')
                                : null;
                // this.selectedChickCategoryView = this.feedDataView[0].data[0].chick_category;
                // this.selectedFormulaView = this.feedDataView[0].data[0].formula;
                this.isFeedDataFetchedView = true;      
                this.feedDataView.forEach((feedData) => {
                    feedData.data.forEach( penData => {
                        penData.feeder_with_feed = this.formatDecimalPoints(penData.feeder_with_feed);
                        penData.feeder_drum_with_feed = this.formatDecimalPoints(penData.feeder_drum_with_feed);
                        this.feederMasterData.forEach( feederData => {
                            if(feederData.id == penData.feeder){
                                penData.feeder_tare_wt = feederData.weight;
                                this.$forceUpdate();
                            }
                        });
                    })
                });
                this.loadingView = false;
                // this.getFeederDrumTareWeightForViewPage();
            })
            .catch((error) => {
                this.feedDataView = [];
                this.$forceUpdate();
                this.isFeedDataFetchedView = false;
                this.loadingView = false;
            })
        }
    },

    // async getFeederDrumTareWeightForViewPage(){
    //     this.loadingView = true;
    //     if (this.selectedChickCategoryView != null) {
    //         this.feedDataView.forEach( feedData => {
    //             feedData.data.forEach((pen) => {
    //                 this.feederDrumMasterData.forEach( drumData => {
    //                     if(drumData.id == pen.feeder_drum){
    //                         if (this.selectedChickCategoryView == 1) {
    //                             pen.feeder_drum_tare_wt = drumData.pst;
    //                             this.$forceUpdate();
    //                         }
    //                         else if (this.selectedChickCategoryView == 2) {
    //                             pen.feeder_drum_tare_wt = drumData.st;
    //                             this.$forceUpdate();
    //                         } 
    //                         else if (this.selectedChickCategoryView == 3) {
    //                             if (this.selectedFormulaView == 1) {
    //                                 pen.feeder_drum_tare_wt = drumData.fn1;
    //                                 this.$forceUpdate();
    //                             } 
    //                             else if (this.selectedFormulaView == 2) {
    //                                 pen.feeder_drum_tare_wt = drumData.fn2;
    //                                 this.$forceUpdate();
    //                             }
    //                         }        
    //                     }
    //                 })
    //                 this.$forceUpdate();
    //             });
    //         })
    //     }
    //     this.loadingView = false;
    // },

    fetchTrialGroup(){
        // if(this.selectedTrial != null){
            this.loading = true;
            this.showError = false;
            // this.selectedChickCategory = '';
            // this.selectedFormula = null;
            this.dayWeek = 1;
            this.penList = [];
            this.$forceUpdate();
            axios.get(`/indous-research/master/trial-group-list?experiment_info_id=${this.selectedTrial}`).then(response=>{
                this.trialGroupList = response.data;
                this.selectedTrialGroup = this.trialGroupList[0].id;
                this.showError = false;
                this.fetchFeedConsumptionData();
            })
            .catch(error=>{
                this.showButtons = false;
                this.loading = false;
                this.showError = true;
                this.$notify({
                                message: error.response.data.message || 'An error occurred',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'danger'
                            });
            });
        // }
    },

    fetchFeedConsumptionData(){
        if(this.selectedTrial && this.dayWeek && this.selectedTrialGroup){
            this.selectedFeedCategory = "";
            this.selectedFormula = "";
            this.penList = [];
            this.$forceUpdate();
            // this.selectedChickCategory = '';
            // this.selectedFormula = null;
            this.loading = true;
            // this.disableChickCategoryButton = false;
            this.showButtons = false;
            this.isFeedDataFetched = false;
            // this.selectedChickCategory = '';
            // this.selectedFormula = null;
            axios.get(`/feed-consumption-data?expId=${this.selectedTrial}&trialId=${this.selectedTrialGroup}&dayWeek=${this.dayWeek}`)
            .then((response) => {
                this.penList = response.data;
                this.isSelectedDateFetched = false; 
                // this.selectedChickCategory = this.penList[0].chick_category;
                // this.selectedFormula = this.penList[0].formula;
                this.selectedFeeder = this.penList[0].feeder;
                this.penList.forEach((pen) => {
                    pen.feeder_with_feed = this.formatDecimalPoints(pen.feeder_with_feed);
                    pen.feeder_drum_with_feed = this.formatDecimalPoints(pen.feeder_drum_with_feed);
                    this.feederMasterData.forEach( feederData => {
                        if(feederData.id == pen.feeder){
                            pen.feeder_tare_wt = feederData.weight;
                            this.$forceUpdate();
                        }
                    });
                });
                this.loading = false;
                this.isFeedDataFetched = true;      
                this.showButtons = true;
                if(this.penList[0] && this.penList[0].date){
                    this.selectedDate = moment(this.penList[0].date).format('YYYY-MM-DD');
                    this.isDateFetched = true;
                }else{
                    this.selectedDate = null;
                    this.isDateFetched = false;
                }
                // this.getFeederDrumTareWeight();
            })
            .catch((error) => {
                this.showButtons = false;
                this.isFeedDataFetched = false;
                this.clearFields();
                this.fetchTrialGroupPen();
                // console.error('Error fetching feed consumption data', error);
            })
        }
    },

    fetchTrialGroupPen(){
        this.loading = true;
        this.selectedFeedCategory = "";
        this.selectedFormula = "";
        this.selectedFeeder = "";
        // this.selectedChickCategory = '';
        // this.selectedFormula = null;
        // this.selectedChickCategory = this.dayWeek <= 7 ? 1 : this.dayWeek <= 21 ? 2 : 3;
        // this.selectedFormula = this.selectedChickCategory == 3 && this.dayWeek > 28 ? 2 : 1;
        axios.get(`/trial-group-pen-list?trial_number=${this.selectedTrial}&trial_group_id=${this.selectedTrialGroup}&day_week=${this.dayWeek}`)
        .then((response) => {
            this.allotedFeedError = [];
            this.dataFetched = false;
            this.penList = response.data.penList;
            this.showButtons = true;
            this.birdCount = response.data.birdCount;
            this.selectedFeeder = this.penList[0].feeder;
            // const chickCategory = response.data.chick_category;
            // if(chickCategory != null){
            //     this.selectedChickCategory = chickCategory;
            //     this.disableChickCategoryButton = true;
            // }
            if (response.data.start_date) {
              const startDate = moment(response.data.start_date, 'YYYY-MM-DD');
              const selectedDay = parseInt(this.dayWeek, 10); 
              this.selectedDate = startDate.clone().add(selectedDay - 1, 'days').format('YYYY-MM-DD'); // Format as YYYY-MM-DD
              this.isSelectedDateFetched = true; 

            } else {
              this.selectedDate = null; // Handle missing start_date
              this.isSelectedDateFetched = false; 
            }
            this.penList.forEach((pen, penIndex) => {
                pen.no_of_birds = Array.isArray(this.birdCount) ? (this.birdCount.length > 0 ? this.birdCount[penIndex].no_of_birds : '') : this.birdCount;
                pen.chick_category = '',
                pen.formula = '',
                // pen.feeder = this.selectedFeeder;
                pen.feeder_with_feed = '';
                pen.feeder_tare_wt = '';
                pen.remaining_feed_from_feeder = '';
                pen.feeder_drum_with_feed = '';
                pen.feeder_drum_tare_wt = '';
                // pen.feeder_drum = '';
                pen.remaining_feed_from_feeder_drum = '';
                pen.alloted_feed_pst = '';
                pen.alloted_feed_st = '';
                pen.alloted_feed_fn1 = '';
                pen.alloted_feed_fn2 = '';
                pen.total_alloted_feed = '';
                pen.consumed_feed = '';
                pen.feed_consumed_per_bird = '';
                pen.remaining_feed = '';
                this.feederMasterData.forEach( feederData => {
                    if(feederData.id == pen.feeder){
                        pen.feeder_tare_wt = feederData.weight;
                        this.$forceUpdate();
                    }
                });
            });
            // this.getFeederDrumTareWeight();
            this.loading = false;
        })
        .catch((error) => {
            this.loading = false;
            this.showButtons = false;
            this.$notify({
                        message: 'Kindly assign pens in corrected feed formula',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });
            // console.error('Error fetching trial details:', error);
        });
    },

    async getFeederDrumTareWeight(pen, index){
        // this.loading = true;
        this.allotedFeed = [];
        this.allotedFeedError = [];
        if(pen == null){
            this.penList.forEach( penItem => {
                penItem.chick_category = this.selectedFeedCategory;
                penItem.formula = this.selectedFormula;
                if (this.selectedFeedCategory == 1 || this.selectedFeedCategory == 2) {
                    this.selectedFormula = '';
                }
            });
            // if(!this.isFeedDataFetched){
                await this.fetchAllotedFeed(this.selectedFeedCategory, this.selectedFormula);
            // }
        } else {
            if (pen.chick_category == 1 || pen.chick_category == 2) {
                pen.formula = '';
            }
            // if(!this.isFeedDataFetched){
                await this.fetchAllotedFeed(pen.chick_category, pen.formula);
            // } 
        }

        if (pen ?.chick_category || this.selectedFeedCategory) {
            // this.penList.forEach((pen, penIndex) => {
                const processPen = (pen) => {
                    this.feederDrumMasterData.forEach( drumData => {
                        if(drumData.id == pen.pen_id){
                            pen.feeder_drum_tare_wt = '';
                            // pen.feeder_drum = drumData.id;
                            if (pen.chick_category == 1) {
                                pen.feeder_drum_tare_wt = drumData.pst;
                                this.$forceUpdate();
                            } else if (pen.chick_category == 2) {
                                pen.feeder_drum_tare_wt = drumData.st;
                                this.$forceUpdate();
                            } else if (pen.chick_category == 3) {
                                if (pen.formula == 1) {
                                    pen.feeder_drum_tare_wt = drumData.fn1;
                                    this.$forceUpdate();
                                } else if (pen.formula == 2) {
                                    pen.feeder_drum_tare_wt = drumData.fn2;
                                    this.$forceUpdate();
                                }
                            }
                        }
                    })
                    // if(!this.isFeedDataFetched){
                        pen.total_alloted_feed = pen.alloted_feed_pst = pen.alloted_feed_st = pen.alloted_feed_fn1 = pen.alloted_feed_fn2 = '';
                        if(this.allotedFeed.length > 0){
                            this.allotedFeed.forEach(item => {
                                if(item.chickCategory == 1){
                                    pen.alloted_feed_pst = item.allotedFeed;
                                    this.$forceUpdate();
                                } else if(item.chickCategory == 2){
                                    pen.alloted_feed_st = item.allotedFeed;
                                    this.$forceUpdate();
                                } else if(item.chickCategory == 3 && item.formula == 1){
                                    pen.alloted_feed_fn1 = item.allotedFeed;
                                    this.$forceUpdate();
                                } else if(item.chickCategory == 3 && item.formula == 2){
                                    pen.alloted_feed_fn2 = item.allotedFeed;
                                    this.$forceUpdate();
                                }
                            })
                        }
                        pen.total_alloted_feed = (Number(pen.alloted_feed_pst) || 0) + (Number(pen.alloted_feed_st) || 0) + (Number(pen.alloted_feed_fn1) || 0) + (Number(pen.alloted_feed_fn2) || 0);
                    // }
                    this.$forceUpdate();
                };

                if(pen == null){
                    this.penList.forEach(penItem => {
                        processPen(penItem);
                    })
                } else {
                    processPen(pen);
                }

                if(index != null){
                    this.calculateFeed(index);
                } else {
                    this.penList.forEach( (penData, index) => {
                        this.calculateFeed(index);
                    })
                }
            // });
        };
        this.loading = false;
    },
    

    calculateRemainingFeedFromFeeder(penIndex){
        if(this.penList[penIndex].feeder_with_feed && this.penList[penIndex].feeder_tare_wt){
            this.penList[penIndex].remaining_feed_from_feeder = (Number(this.penList[penIndex].feeder_with_feed) - Number(this.penList[penIndex].feeder_tare_wt));
            this.$forceUpdate();
        } else {
            this.penList[penIndex].remaining_feed_from_feeder = '';
            this.$forceUpdate();
        }
    },
    calculateRemainingFeedFromFeederDrum(penIndex){
        if(this.penList[penIndex].feeder_drum_with_feed && this.penList[penIndex].feeder_drum_tare_wt){
            this.penList[penIndex].remaining_feed_from_feeder_drum = (Number(this.penList[penIndex].feeder_drum_with_feed) - Number(this.penList[penIndex].feeder_drum_tare_wt));
            this.$forceUpdate();
        } else {
            this.penList[penIndex].remaining_feed_from_feeder_drum = '';
            this.$forceUpdate();
        }
    },
    calculateFeed(penIndex){
        this.calculateRemainingFeedFromFeeder(penIndex);
        this.calculateRemainingFeedFromFeederDrum(penIndex);
        if (this.penList[penIndex].remaining_feed_from_feeder !== null && this.penList[penIndex].remaining_feed_from_feeder !== '' && this.penList[penIndex].remaining_feed_from_feeder >= 0 &&
            this.penList[penIndex].remaining_feed_from_feeder_drum !== null && this.penList[penIndex].remaining_feed_from_feeder_drum !== '' && this.penList[penIndex].remaining_feed_from_feeder_drum >= 0) {
            this.penList[penIndex].remaining_feed = (Number(this.penList[penIndex].remaining_feed_from_feeder) + Number(this.penList[penIndex].remaining_feed_from_feeder_drum));
            this.penList[penIndex].consumed_feed = (Number(this.penList[penIndex].total_alloted_feed) - Number(this.penList[penIndex].remaining_feed));
            this.$forceUpdate();
            if(this.penList[penIndex].no_of_birds > 0){
                this.penList[penIndex].feed_consumed_per_bird = (Number(this.penList[penIndex].consumed_feed) / Number(this.penList[penIndex].no_of_birds)).toFixed(3);
                this.$forceUpdate();
            } else {
                this.penList[penIndex].feed_consumed_per_bird = '';
                this.$forceUpdate();
            }
        } else {
            this.penList[penIndex].remaining_feed = '';
            this.penList[penIndex].consumed_feed = '';
            this.penList[penIndex].feed_consumed_per_bird = '';
            this.$forceUpdate();
        }
        
    },

    async fetchAllotedFeed(chick_category, formula){
        // this.loading = true;
        this.allotedFeedError = [];
        try {
            const response = await axios.get(`/fetch-allocated-feed?expId=${this.selectedTrial}&trialGroupId=${this.selectedTrialGroup}&chick_category=${chick_category}&formula=${formula}`)
            const expectedLengths = {
                1: 1,
                2: 2,
                3: {
                    1: 3,
                    2: 4
                }
            };

            let expectedLength = chick_category === 3
                ? expectedLengths[3][formula]
                : expectedLengths[chick_category];

            if (response.data.length === expectedLength) {
                this.allotedFeed = response.data;
            } else {
                this.allotedFeedError.push('Please perform the allotment for Pre-Starter, Starter, and Finisher in the Corrected Feed Formula');
            }

            if (this.allotedFeedError.length > 0) {
                this.$notify({
                    message: this.allotedFeedError[0] || 'An error occurred',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            }
            
        } catch (error) {
            this.loading = false;
            // console.error('Error fetching Alloted feed data ', error);
        }
    },

    async feedCalculation(pen, index){
        // this.loading = true;
        await this.getFeederDrumTareWeight(pen, index);
        // this.penList.forEach((pen, penIndex) => {
        // })
    },

    getFeederTareWeight(feederId){
        this.penList.forEach( (penData, penIndex) => {
            this.feederMasterData.forEach( item => {
                if(item.id == feederId){
                    penData.feeder = feederId;
                    penData.feeder_tare_wt = item.weight;
                    this.$forceUpdate();
                    this.calculateFeed(penIndex);
                }
            });
        })
    },

    formatDecimalPoints(value) {
      if (value !== null && value !== undefined && value !== "") {
        return Number(value) % 1 === 0
          ? Number(value).toFixed(0)
          : Number(value).toFixed(3);
      }
      return "";
    },

    convertKgToGrams(kg) {
        const kgNumber = Number(kg);
        
        if (isNaN(kgNumber)) {
            throw new Error('Input must be a number or a valid numeric string');
        }
        return kgNumber * 1000;
    },
    
    clearFields(){
        this.selectedFeedCategory = '';
        this.selectedFormula = '';
        this.selectedFeeder = '';
        if(this.penList.length > 0){
            this.penList.forEach(pen => {
                pen.chick_category = '';
                pen.formula = '';
                pen.feeder = '';
                pen.feeder_with_feed = '';
                pen.feeder_tare_wt = '';
                pen.remaining_feed_from_feeder = '';
                pen.feeder_drum_with_feed = '';
                pen.feeder_drum_tare_wt = '';
                pen.remaining_feed_from_feeder_drum = '';
                pen.alloted_feed_pst = '';
                pen.alloted_feed_st = '';
                pen.alloted_feed_fn1 = '';
                pen.alloted_feed_fn2 = '';
                pen.total_alloted_feed = '';
                pen.consumed_feed = '';
                pen.feed_consumed_per_bird = '';
                pen.remaining_feed = '';
                this.$forceUpdate();
            });
        }
    },

    submit(value) {
        const saveData = {};
        saveData.dayWeek = this.dayWeek;
        saveData.trialGroup = this.selectedTrialGroup;
        saveData.penData = this.penList;
        saveData.experimentId = this.selectedTrial;
        saveData.date = this.selectedDate;
        // saveData.chickCategory = this.selectedChickCategory;
        // saveData.formula = this.selectedFormula;
        
        if(value == 'update') {
            this.upDateStatus = true;
            axios
                .put("/feed-consumption-per-bird-update", saveData)
                .then((response) => {
                    this.upDateStatus = false;
                    this.$notify({
                        message: response.data.message,
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'success'
                    });
                    this.fetchFeedConsumptionData();
                })
                .catch((error) => {
                    this.upDateStatus = false;
                    this.errors = Object.values(error.response.data.errors).flat();
                    this.$notify({
                        message: error.response.data.error || this.errors[0] || 'An error occurred',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });
                });
        }
        else if(value == 'save'){
            this.saveStatus = true;
            axios
                .post("/feed-consumption-per-bird-save", saveData)
                .then((response) => {
                    this.saveStatus = false;
                    this.$notify(
                        {
                            message:response.data.message,
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'success'
                        })
                    this.fetchFeedConsumptionData();
                })
                .catch((error) => {
                    this.saveStatus = false;
                    this.errors = Object.values(error.response.data.errors).flat();
                    this.$notify({
                        message: error.response.data.error || this.errors[0] || 'An error occurred',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });
                });
        }
    },
  }
};

</script>
<style scoped>
.checkbox-select__trigger.isActive {
    border-radius: 10px 10px 0 0;
    background: #f2f2f2;
}
.readonly-select {
    pointer-events: none; 
    background-color: #fff; 
    color: #000; 
    border: 1px solid #ced4da; 
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.2;
    appearance: none; 
    -moz-appearance: none;
    -webkit-appearance: none;
}
.readonly-select::after {
    content: "▼";
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none; 
}
table input {
  width: 100%;
  box-sizing: border-box;
  height: 40px;
}
</style>